export default "__VITE_ASSET__CYAfA0or__"